'use strict';

import angular from 'angular';
import routes from './admin.routes';
import AllgroupsController from './allgroups.controller';
var localisations = require('./admin.localisations');

export default angular.module('ffApp.allgroups', ['ffApp.auth', 'ngRoute'])
  .config(routes)
  .controller('allgroupsBottomSheetCtrl', function(GLOBALS, Auth, Util, common, $scope, $timeout, $mdBottomSheet, groups) {
    'ngInject'

    $scope.localisations = localisations[common.getLocale()];
    $scope.saving = false;
    $scope.newMessage = '';
    $scope.common = common;
    $scope.messageUpload = null;
    $scope.msgLength = GLOBALS.msgLength + 500;
    $scope.currentGroup = groups.getCurrentGroup();
    console.log($scope.currentGroup);

    $timeout(function(){
      // SET UP LISTENER FOR FILE UPLOAD - ANGULAR BINDINGS NOT READY IN FILEUPLAOD
      if(window.File && window.FileReader && window.FileList && window.Blob) {
        document.getElementById('messageFile').addEventListener('change', function() {
          $scope.uploadNewImage();
        }, false);
      } else {
        $scope.common.setAlert('File Upload Error', 'danger', 'The File APIs are not fully supported in this browser. Please get with the programme and use a modern browser! :) ', false, true);
      }
    }, 250);
    

    $scope.createMessage = function(msg) {
      groups.postNewMessage($scope.newMessage, null, null, $scope.messageUpload, true, function() {
        $scope.newMessage = '';
        $scope.messageUpload = null;
        $scope.hideBottomSheet();
      }, function() {});
    };

    $scope.hideBottomSheet = function() {
      $mdBottomSheet.hide();
    };

    $scope.uploadNewImage = function() {      
      var file = document.getElementById('messageFile').files[0];
      console.log(file);
      if(file) {
        $scope.common.setLoading(true);
        var reader = new FileReader();

        reader.onload = function(readerEvt) {
          var binaryString = readerEvt.target.result;
          $scope.messageUpload = btoa(binaryString);
          console.log($scope.messageUpload);
          $scope.$apply();
          $scope.common.setLoading(false);
        };
        reader.readAsBinaryString(file);
      }
    };

    $scope.removeImage = function() {
      $scope.messageUpload = null;
    };
  })
  .controller('AllgroupsController', AllgroupsController)
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/groups.js